// 引入各种业务的js
import system from "./system.js";
import device from "./device.js";
import growthModel from "./growthModel.js"
import comparison from "./comparison.js"
import offline from "./offline.js"
import photosynthesis from "./photosynthesis.js"
import homeParam from "./homeParam.js"
import groupAlarm from "./groupAlarm.js"
import fish from "./fish.js"

export default {
    system,
    device,
    growthModel,
    comparison,
    offline,
    photosynthesis,
    homeParam,
    groupAlarm,
    fish,
}